import styled from "styled-components";

export const BodyContainer = styled.p`
  color: ${({ theme }) => theme.old.colors.gray[525]};
  font-size: ${({ theme }) => theme.old.fonts.size.small};
  font-weight: ${({ theme }) => theme.old.fonts.weight.medium};
  line-height: 20px;
  margin: 12px 0;

  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;

  & button {
    border: none;
    background-color: transparent;
    color: white;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    width: max-content;
    cursor: pointer;
  }
`
